// eslint-disable-next-line no-unused-vars
import { INNER_ROOT, USER_ROOT, transmission, WEB_METHODS } from '../../network/index'

const ROOT = '/ticket'

const state = {
  ticketList: [],
  ticketRefreshTriggerCount: 0
}

const mutations = {
  initTicketList (state, payload){
    state.ticketList = payload
  },
  incrementTicketRefreshTrigger (state){
    ++state.ticketRefreshTriggerCount
  },
}

/**
 * Actions Naming Rule
 * 기본문법 : CamelCase
 * 작문 : { 메소드 }{ 명칭 }{ 결과타입 }
 *
 * 메소드 예 *
 *  get, post, put, delete 등
 * 명칭 예 *
 *  상담사 : counselor 등
 * 결과 타입 예 *
 *  목록 : List
 *  단건결과 : 없음 등
 */
const actions = {

  /**
   * 회원가입 > 기업회원 > 티켓코드 인증
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getMemberAgency ({commit}, payload) {
    return transmission(false, WEB_METHODS.GET, `${INNER_ROOT + ROOT}/ticketCode/check/{ticketCode}`, payload)
  },

  /**
   * 사용자 > 티켓 > 유저 삼성 티켓 리스트 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getFireTicketList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/fire-tickets`)
  },


  /**
   * 사용자 > 티켓 > 유저 삼성 티켓 체크 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getFireTicketCheck ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/fire-tickets/check`)
  },

  /**
   * 사용자 > 티켓 > 유저 티켓 사용 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async insertUserTicket ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/use`, payload)
  },

  /**
   * 사용자 > 티켓 > 내 티켓 리스트 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getMyTicketList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/my-tickets`, payload)
  },

  /**
   * 사용자 > 티켓 > 유저 티켓 리스트 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getTicketList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/tickets`)
  },

  /**
   * 사용자 > 티켓 > 유저 티켓 등록 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async updateUserTicketCd ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/ticket-cd`, payload)
  },


}
const getters = {
  ticketList(state) {
    return state.ticketList
  }
}

export default { state, mutations, actions, getters }
